(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eu-buy"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(scope){
      (scope||document).querySelectorAll('[data-eu-buy]').forEach(function(root){
        if(root.dataset.euBuyReady) return;
        var dataEl=root.querySelector('[data-sbb-data]');
        if(!dataEl) return;
        root.dataset.euBuyReady='1';
        var cfg=JSON.parse(dataEl.textContent);
        var firstScent=root.querySelector('[data-scent]');
        var scent=firstScent?firstScent.getAttribute('data-scent'):null;
        var planMode=cfg.defaultPlan==='one'?'one':'sub';

        function money(c){
          try{ return (c/100).toLocaleString(undefined,{style:'currency',currency:cfg.currency}); }
          catch(e){ return (c/100).toFixed(2); }
        }
        function find(size){
          return cfg.variants.filter(function(v){
            var okS=String(v.options[cfg.sizeIndex])===String(size);
            var okC=(scent===null)||String(v.options[cfg.scentIndex])===String(scent);
            return okS&&okC;
          })[0];
        }
        function render(){
          var anyPlans=false;
          root.querySelectorAll('.sbb__card').forEach(function(card){
            var v=find(card.getAttribute('data-size'));
            var price=card.querySelector('[data-card-price]'),
                buy=card.querySelector('[data-card-buy]'),
                img=card.querySelector('[data-card-img]'),
                tgl=card.querySelector('[data-plan-toggle]'),
                saveEl=card.querySelector('[data-card-save]');
            if(!v){ if(price) price.textContent=''; if(buy) buy.setAttribute('href','#'); return; }
            if(img){
              var src=(v.featured_image&&v.featured_image.src)?v.featured_image.src:cfg.fallbackImage;
              if(src && img.getAttribute('src')!==src) img.setAttribute('src',src);
            }
            var plans=(cfg.plans&&cfg.plans[v.id])||[];
            var plan=null;
            if(plans.length){
              anyPlans=true;
              if(tgl) tgl.hidden=false;
              if(planMode==='sub'){
                plan=plans.slice().sort(function(a,b){ return a.price-b.price; })[0];
              }
            }
            else if(tgl){ tgl.hidden=true; }
            var shown=plan?plan.price:v.price;
            var was=plan?v.price:((v.compare_at_price&&v.compare_at_price>v.price)?v.compare_at_price:null);
            if(price){
              var html='<span>'+money(shown)+'</span>';
              if(was&&was>shown){ html+='<span class="sbb__was">'+money(was)+'</span>'; }
              price.innerHTML=html;
            }
            if(saveEl){ saveEl.textContent=(plan&&v.price>plan.price)?('Save '+money(v.price-plan.price)+' every delivery'):''; }
            if(buy){
              if(!v.available){
                buy.setAttribute('href','#'); buy.setAttribute('aria-disabled','true');
                buy.style.opacity='.45'; buy.style.pointerEvents='none'; buy.textContent=cfg.soldOut; return;
              }
              buy.style.opacity=''; buy.style.pointerEvents=''; buy.removeAttribute('aria-disabled');
              buy.setAttribute('href','#');
              buy.dataset.variant=v.id;
              buy.dataset.plan=plan?plan.id:'';
            }
          });
          if(giftEl){ giftEl.hidden = !(anyPlans && planMode==='sub'); }
          var duo=root.querySelector('[data-duo]');
          if(duo&&cfg.rollerVariant){
            var fv=null;
            if(cfg.duoSize){
              fv=cfg.variants.filter(function(v){
                var okS=String(v.options[cfg.sizeIndex])===String(cfg.duoSize);
                var okC=!cfg.duoScent||String(v.options[cfg.scentIndex])===String(cfg.duoScent);
                return okS&&okC;
              })[0];
            }
            if(!fv){
              var flagged=root.querySelector('.sbb__card--flag')||root.querySelector('.sbb__card');
              fv=flagged?find(flagged.getAttribute('data-size')):null;
            }
            if(fv){
              var url=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/'+fv.id+':1,'+cfg.rollerVariant+':1';
              if(cfg.discount){ url+='?discount='+encodeURIComponent(cfg.discount); }
              duo.setAttribute('href',url);
              var full=fv.price+cfg.rollerPrice;
              var saving=(cfg.duoMode==='fixed') ? cfg.duoFixed : Math.round(full*cfg.duoPercent/100);
              if(saving>full) saving=full;
              var now=full-saving;
              var elNow=root.querySelector('[data-duo-now]'),
                  elWas=root.querySelector('[data-duo-was]'),
                  elSave=root.querySelector('[data-duo-save]'),
                  dm=root.querySelector('[data-duo-main]');
              if(elNow) elNow.textContent=money(now);
              if(elWas) elWas.textContent=money(full);
              if(elSave) elSave.textContent='You save '+money(saving);
              if(dm){
                var ds=(fv.featured_image&&fv.featured_image.src)?fv.featured_image.src:cfg.fallbackImage;
                if(ds&&dm.getAttribute('src')!==ds) dm.setAttribute('src',ds);
              }
            }
          }
        }

        var giftEl=root.querySelector('[data-gift]');
        var giftDataEl=root.querySelector('[data-gift-data]');
        var gift=giftDataEl?JSON.parse(giftDataEl.textContent):null;
        var modal=root.querySelector('[data-modal]');
        var grid=root.querySelector('[data-modal-grid]');
        var note=root.querySelector('[data-modal-note]');
        var confirm=root.querySelector('[data-modal-confirm]');
        var chosen=(gift&&gift.variants&&gift.variants.length)?gift.variants[0].id:null;
        var pending=null;

        function drawMod(){
          if(!grid||!gift) return;
          grid.innerHTML='';
          gift.variants.forEach(function(g){
            var b=document.createElement('button');
            b.type='button'; b.className='sbb__mc';
            b.setAttribute('aria-pressed', String(g.id===chosen));
            b.innerHTML='<img src="'+g.img+'" alt="'+g.name+'"><p class="sbb__mcn">'+g.name+'</p>'+
                        '<p class="sbb__mcp"><s>'+money(gift.worth)+'</s><strong>'+cfg.freeWord+'</strong></p>';
            b.addEventListener('click',function(){ chosen=g.id; drawMod(); });
            grid.appendChild(b);
          });
        }
        function openMod(){ if(modal){ drawMod(); modal.classList.add('is-open'); } }
        function closeMod(){ if(modal){ modal.classList.remove('is-open'); } }
        root.querySelectorAll('[data-modal-close]').forEach(function(x){ x.addEventListener('click',function(e){ e.preventDefault(); closeMod(); }); });
        document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeMod(); });

        // only one mask is free, so never offer a second
        function maskInCart(cb){
          if(!gift){ cb(false); return; }
          var ids=gift.variants.map(function(g){ return g.id; });
          fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js',{cache:'no-store',credentials:'same-origin'})
            .then(function(r){ return r.json(); })
            .then(function(c){ cb((c.items||[]).some(function(i){ return ids.indexOf(i.variant_id)!==-1||ids.indexOf(i.id)!==-1; })); })
            .catch(function(){ cb(false); });
        }

        function addToCart(btn, variantId, planId, giftId){
          var label=btn.textContent;
          btn.style.pointerEvents='none'; btn.textContent=cfg.addingLabel;
          var items=[{id:parseInt(variantId,10),quantity:1}];
          if(planId) items[0].selling_plan=parseInt(planId,10);
          if(giftId) items.push({id:parseInt(giftId,10),quantity:1,properties:{_sleep_mask_addon:'true',_sleep_mask_source:cfg.giftSource}});
          fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:items,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})
          })
          .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw new Error(d.description||d.message||('HTTP '+r.status)); return d; }); })
          .then(function(data){
            btn.textContent=cfg.addedLabel;
            var drawer=document.querySelector('cart-drawer');
            if(drawer){
              drawer.classList.remove('is-empty');
              if(typeof drawer.renderContents==='function'&&data.sections) drawer.renderContents(data);
              else if(typeof drawer.open==='function') drawer.open();
            }
            setTimeout(function(){ btn.textContent=label; btn.style.pointerEvents=''; },2200);
          })
          .catch(function(){
            btn.textContent=label; btn.style.pointerEvents='';
            window.location.href=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/'+variantId+':1'+(planId?('?selling_plan='+planId):'');
          });
        }

        root.addEventListener('click',function(e){
          var btn=e.target.closest('[data-card-buy]');
          if(!btn||btn.getAttribute('aria-disabled')) return;
          e.preventDefault();
          var v=btn.dataset.variant, pl=btn.dataset.plan;
          if(!v) return;
          if(gift && pl){
            maskInCart(function(has){
              if(has){
                if(note){ note.hidden=false; }
                addToCart(btn,v,pl,null);
              } else {
                pending=btn; if(note){ note.hidden=true; } openMod();
              }
            });
          } else {
            addToCart(btn,v,pl,null);
          }
        });
        if(confirm){
          confirm.addEventListener('click',function(e){
            e.preventDefault(); closeMod();
            if(pending) addToCart(pending, pending.dataset.variant, pending.dataset.plan, chosen);
          });
        }
        root.querySelectorAll('[data-plan]').forEach(function(btn){
          btn.addEventListener('click',function(){
            planMode=btn.getAttribute('data-plan');
            root.querySelectorAll('[data-plan]').forEach(function(b){
              b.setAttribute('aria-pressed', b.getAttribute('data-plan')===planMode?'true':'false');
            });
            render();
          });
        });
        root.querySelectorAll('[data-scent]').forEach(function(btn){
          btn.addEventListener('click',function(){
            scent=btn.getAttribute('data-scent');
            root.querySelectorAll('[data-scent]').forEach(function(b){
              b.setAttribute('aria-pressed', b===btn?'true':'false');
            });
            render();
          });
        });
        render();
      });
    }
    if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',function(){ init(); }); }
    document.addEventListener('shopify:section:load',function(e){ init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eu-film"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(scope){
      (scope||document).querySelectorAll('[data-eu-film]').forEach(function(root){
        if(root.dataset.euFilmReady) return;
        root.dataset.euFilmReady='1';

        var openBtn=root.querySelector('[data-film-open]');
        var box=root.querySelector('[data-film-box]');
        var slot=root.querySelector('[data-film-slot]');
        var closeBtn=root.querySelector('[data-film-close]');
        var src=root.getAttribute('data-src');
        if(!openBtn||!box||!slot||!src) return;

        var lastFocus=null;

        function open(){
          lastFocus=document.activeElement;
          // Built on demand, so nothing downloads until this point.
          var video=document.createElement('video');
          video.setAttribute('controls','');
          video.setAttribute('playsinline','');
          video.setAttribute('preload','auto');
          video.src=src;
          slot.appendChild(video);
          box.classList.add('on');
          document.body.style.overflow='hidden';
          video.play().catch(function(){});
          if(closeBtn) closeBtn.focus();
        }

        function close(){
          var video=slot.querySelector('video');
          if(video){ video.pause(); video.removeAttribute('src'); video.load(); slot.removeChild(video); }
          box.classList.remove('on');
          document.body.style.overflow='';
          if(lastFocus && lastFocus.focus) lastFocus.focus();
        }

        openBtn.addEventListener('click',open);
        if(closeBtn) closeBtn.addEventListener('click',close);
        box.addEventListener('click',function(e){ if(e.target===box) close(); });
        document.addEventListener('keydown',function(e){
          if(e.key==='Escape' && box.classList.contains('on')) close();
        });
      });
    }
    if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',function(){ init(); }); }
    document.addEventListener('shopify:section:load',function(e){ init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eu-steps"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(scope){
      (scope||document).querySelectorAll('[data-eu-steps]').forEach(function(rail){
        if(rail.dataset.euStepsReady) return;
        rail.dataset.euStepsReady='1';
        var track=rail.querySelector('[data-rail]'), dots=rail.querySelector('[data-dots]');
        if(!track||!dots) return;
        var d=dots.querySelectorAll('span');
        if(!d.length) return;
        track.addEventListener('scroll',function(){
          var i=Math.round(track.scrollLeft/(track.scrollWidth/d.length));
          for(var n=0;n<d.length;n++){ d[n].classList.toggle('on', n===Math.min(i,d.length-1)); }
        },{passive:true});
      });
    }
    if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',function(){ init(); }); }
    document.addEventListener('shopify:section:load',function(e){ init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eu-sticky"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(scope){
      (scope||document).querySelectorAll('[data-eu-sticky]').forEach(function(bar){
        if(bar.dataset.euStickyReady) return;
        bar.dataset.euStickyReady='1';
        var after=parseInt(bar.getAttribute('data-show-after'),10)||600;
        // Theme url settings store ONE value shared by every market, so a
        // /cart/... link drops an EU shopper into the GB market. Re-point any
        // same-host link at the market the visitor is actually in. Done twice:
        // once up front, and again at click time, because a third-party script
        // rewrites these hrefs to absolute URLs after load.
        function marketUrl(href){
          var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
          if(root==='/'||!href) return null;
          var u; try{ u=new URL(href,window.location.href); }catch(err){ return null; }
          if(u.host!==window.location.host) return null;
          if(u.pathname.indexOf(root)===0) return null;
          u.pathname=root.replace(/\/$/,'')+u.pathname;
          return u.toString();
        }
        bar.querySelectorAll('a[href]').forEach(function(a){
          var fixed=marketUrl(a.getAttribute('href'));
          if(fixed) a.setAttribute('href',fixed);
        });
        bar.addEventListener('click',function(e){
          var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;
          if(!a||!bar.contains(a)) return;
          var fixed=marketUrl(a.getAttribute('href'));
          if(!fixed) return;
          e.preventDefault();
          window.location.href=fixed;
        },true);
        function hidden(){
          var last=document.querySelector('.sb-eu-last')||document.querySelector('footer');
          return last ? last.getBoundingClientRect().top < window.innerHeight - 80 : false;
        }
        function upd(){
          var on = window.scrollY > after && !hidden();
          bar.classList.toggle('on', on);
          document.body.style.paddingBottom = on ? bar.offsetHeight + 'px' : '';
        }
        window.addEventListener('scroll',upd,{passive:true});
        window.addEventListener('resize',upd);
        upd();
      });
    }
    if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',function(){ init(); }); }
    document.addEventListener('shopify:section:load',function(e){ init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
  class TextVideoCustomPlayer {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.sectionId = this.section.dataset.sectionId;

      this.contentLayout = this.section.querySelector(`#TextVideoLayoutContent--${this.sectionId}`);
      this.layoutToggleButton = this.section.querySelector(`#ToggleLayoutBtn--${this.sectionId}`);

      this.videoPlayerContainer = this.section.querySelector('.video-player-container');
      if (this.videoPlayerContainer) {
        this.videoElement = this.section.querySelector(`#HostedVideo--${this.sectionId}`);
        this.customPlayButton = this.videoPlayerContainer.querySelector('.custom-play-button');
        this.videoOverlay = this.videoPlayerContainer.querySelector('.video-overlay');
        this.showNativeControls = this.videoPlayerContainer.dataset.showNativeControls === 'true';
      }
      this.init();
    }

    init() {
      if (this.layoutToggleButton && this.contentLayout) {
        this.layoutToggleButton.addEventListener('click', () => {
          this.contentLayout.classList.toggle('layout-reversed');
          const isPressed = this.contentLayout.classList.contains('layout-reversed');
          this.layoutToggleButton.setAttribute('aria-pressed', isPressed.toString());
        });
      }

      if (this.videoElement && this.customPlayButton && this.videoOverlay) {
        this.initVideoPlayer();
      }
    }

    initVideoPlayer() {
      this.customPlayButton.addEventListener('click', () => {
        if (this.videoOverlay) {
          this.videoOverlay.classList.add('is-hidden');
        }
        this.videoElement.play().catch((error) => {
          console.error('Video play failed for section ' + this.sectionId + ':', error);
          if (this.videoOverlay) {
            // this.videoOverlay.classList.remove('is-hidden');
          }
        });
        if (this.showNativeControls) {
          this.videoElement.controls = true;
        }
      });
    }
  }

  function initializeSections() {
    document.querySelectorAll('[data-section-type="text-video-custom-player"]').forEach((sectionElement) => {
      if (!sectionElement.textVideoCustomPlayerInstance) {
        sectionElement.textVideoCustomPlayerInstance = new TextVideoCustomPlayer(sectionElement);
      }
    });
  }

  initializeSections();

  document.addEventListener('shopify:section:load', function (event) {
    const sectionElement = event.target;
    if (sectionElement.dataset.sectionType === 'text-video-custom-player') {
      sectionElement.textVideoCustomPlayerInstance = new TextVideoCustomPlayer(sectionElement);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
